import { useEffect } from 'react';
import { get } from 'lodash';

import { EMPLOYMENT_TYPE, FIELD_PATHS } from '@funnels/constants';
import { useCustomer, useFormValues } from '@funnels/hooks';
import { ApplicantEntityIndex, StoreEmployment } from '@funnels/types';
import { CompanyMerger } from '@funnels/ui-components/RelatedCompany';
import { Card } from '@funnels/ui-layouts/customer-view/_common';
import { initialFormValues, maskPIIFullStory } from '@funnels/utils';

import { EmploymentSituation } from '../../Layout';

interface CurrentEmploymentProps extends ApplicantEntityIndex {
  isFromSummary?: boolean;
}

export const CurrentEmployment = (props: CurrentEmploymentProps) => {
  const { applicantIndex, isFromSummary } = props;
  const customer = useCustomer();
  const [formValues, setFormValue] = useFormValues();
  const applicantId = get(formValues, FIELD_PATHS.APPLICANT_ID(applicantIndex));
  const applicantCustomerId = get(formValues, FIELD_PATHS.APPLICANT_CUSTOMER_ID(applicantIndex));
  const applicantFirstName = get(formValues, FIELD_PATHS.APPLICANT_FIRST_NAME(applicantIndex));
  const isLoggedInApplicant = applicantCustomerId === customer.data.id;
  const employments: StoreEmployment[] = get(formValues, FIELD_PATHS.EMPLOYMENTS(), []);
  const primaryEmploymentIndex = employments.findIndex(
    (_, index) =>
      get({ employments }, FIELD_PATHS.EMPLOYMENT_TYPE(index)) === EMPLOYMENT_TYPE.PRIMARY &&
      get({ employments }, FIELD_PATHS.EMPLOYMENT_APPLICANT_ID(index)) === applicantId
  );

  useEffect(() => {
    // just in case there is no primary employment
    if (primaryEmploymentIndex === -1) {
      const newPrimaryEmployment = initialFormValues.INITIAL_EMPLOYMENT_V2(applicantId, EMPLOYMENT_TYPE.PRIMARY);
      setFormValue(FIELD_PATHS.EMPLOYMENT(employments.length), newPrimaryEmployment);
    }
  }, [applicantId, employments.length, primaryEmploymentIndex, setFormValue]);

  const heading = isLoggedInApplicant ? (
    `What's your current employment situation?`
  ) : (
    <>What's {maskPIIFullStory(applicantFirstName)}'s current employment situation?</>
  );

  if (primaryEmploymentIndex === -1) return null;

  return (
    <Card heading={heading} actionCustomText={isFromSummary ? 'Save' : 'Next'}>
      <CompanyMerger />
      <EmploymentSituation employmentIndex={primaryEmploymentIndex} applicantId={applicantId} />
    </Card>
  );
};
